/**
 * Brand client reference ID for Stripe / MercadoPago payment URLs.
 *
 * Reads from brandConfig so it adapts when VITE_BRAND_SOURCE_KEY changes in Vercel.
 */

import { BRAND_SOURCE_KEY, BRAND_CLIENT_REFERENCE_ID } from "@/lib/brandConfig";

export { BRAND_CLIENT_REFERENCE_ID };

/**
 * Append `client_reference_id=<BRAND_SOURCE_KEY>` to a Stripe or MercadoPago payment URL.
 * Works on buy.stripe.com, checkout.stripe.com, mpago.la, mercadopago.com.
 */
export function appendBrandReferenceId(url: string): string {
  if (!url) return url;

  const isPaymentUrl =
    url.includes("stripe.com") ||
    url.includes("mpago.la") ||
    url.includes("mercadopago.com");

  if (!isPaymentUrl) return url;

  try {
    const urlObj = new URL(url);
    if (!urlObj.searchParams.has("client_reference_id")) {
      urlObj.searchParams.set("client_reference_id", BRAND_CLIENT_REFERENCE_ID);
    }
    return urlObj.toString();
  } catch {
    if (!url.includes("client_reference_id")) {
      const sep = url.includes("?") ? "&" : "?";
      return `${url}${sep}client_reference_id=${BRAND_CLIENT_REFERENCE_ID}`;
    }
    return url;
  }
}

export function hasBrandReferenceId(url: string): boolean {
  return url.includes(`client_reference_id=${BRAND_SOURCE_KEY}`);
}

export default {
  BRAND_CLIENT_REFERENCE_ID,
  appendBrandReferenceId,
  hasBrandReferenceId,
};
